import { Component, Input, OnInit, inject } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { PatientAttachmentsService } from '../../../core/services/patient-attachments.service';
import { MatchingPatientPrescriber } from '../../../core/models/matching-patient-prescriber.model';
import { MatIcon } from '@angular/material/icon';

import { ValidateReferralMatchVerificationsPrescriberComponent } from '../validate-referral-match-verifications-prescriber/validate-referral-match-verifications-prescriber.component';

@Component({
    selector: 'app-validate-referral-match-verifications',
    templateUrl: './validate-referral-match-verifications.component.html',
    styleUrls: ['./validate-referral-match-verifications.component.scss'],
    imports: [MatIcon, ValidateReferralMatchVerificationsPrescriberComponent]
})
export class ValidateReferralMatchVerificationsComponent implements OnInit {
  private patientAttachmentsService = inject(PatientAttachmentsService);

  _patientAttachment: PatientAttachment;
  matchingPatientPrescribers: MatchingPatientPrescriber[] = [];

  ngOnInit() {}

  get patientAttachment(): PatientAttachment {
    return this._patientAttachment;
  }

  @Input()
  set patientAttachment(pa: PatientAttachment) {
    this._patientAttachment = pa;
    this.initializeMatchingPatientPrescribers();
  }

  private initializeMatchingPatientPrescribers() {
    this.patientAttachmentsService
      .getMatchingPatientPrescribers(this.patientAttachment.id)
      .subscribe((mpps: MatchingPatientPrescriber[]) => {
        this.matchingPatientPrescribers = mpps;
      });
  }
}
